import { render, staticRenderFns } from "./chateau-de-ferrand.vue?vue&type=template&id=3735262b&scoped=true"
import script from "./chateau-de-ferrand.vue?vue&type=script&lang=js"
export * from "./chateau-de-ferrand.vue?vue&type=script&lang=js"
import style0 from "./chateau-de-ferrand.vue?vue&type=style&index=0&id=3735262b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735262b",
  null
  
)

export default component.exports